import { render, staticRenderFns } from "./SharedTips.vue?vue&type=template&id=fbe836e8&scoped=true&"
import script from "./SharedTips.vue?vue&type=script&lang=js&"
export * from "./SharedTips.vue?vue&type=script&lang=js&"
import style0 from "./SharedTips.vue?vue&type=style&index=0&id=fbe836e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe836e8",
  null
  
)

export default component.exports